// React
import React, { useState, useEffect, useContext } from "react";

import { useTranslation } from "react-i18next";

// Styled components
import { KanbanCardContainer, KanbanCardAvatar, KanbanContent, IsInvited, KanBanSelector } from "./KanbanCard.styled";
import { Flex } from "../../../../style";
import { Row } from "../../../../../components/Grid";

// Components
import KanbanCardStars from "./KanbanCardStars/KanbanCardStars";

// Assets
import anonymousAvatar from "../../../../../assets/icons/anonymous-avatar.svg";

// State management
import { DispatchPositionContext, StatePositionContext } from "../../../../context/PositionContext";
import { useKanbanState, useKanbanDispatch } from "../../../../context/KanbanContext";
import { Typography } from "../../../../../components/Typography";
import useTimeAgo from "../../../../hooks/useTimeAgo";

const KanbanCard = ({ application, activeApplicationId, setActiveApplicationId, initial, setInitial, manageShareholder }) => {
  const { t } = useTranslation();
  const [avatar, setAvatar] = useState(anonymousAvatar);
  const { short: createdAtLabel } = useTimeAgo(application.createdAt);
  const candidateFullName = `${application.applicant.candidate.firstName} ${application.applicant.candidate.lastName}`;
  const hasLongName = candidateFullName.length > 25;
  const candidateDisplayName = hasLongName ? `${candidateFullName.slice(0, 25)}...` : candidateFullName;
  const candidateInitials = `${application?.applicant?.candidate?.firstName?.charAt(0).toUpperCase() || ""}${application?.applicant?.candidate?.lastName?.charAt(0).toUpperCase() || ""}`;

  // useEffect(() => {
  //   const getProfileImage = (application) => {
  //     if (application.externalProfileImage) {
  //       setAvatar(application.externalProfileImage);
  //       return;
  //     }
  //     const { files } = application;
  //     if (files) {
  //       const profileImage = files.find(
  //         (fileObject) => fileObject.docType === "profileImage",
  //       );
  //       if (profileImage) {
  //         setAvatar(profileImage.signedRequest);
  //       }
  //     }
  //   };
  //   getProfileImage(application);
  // }, [application]);

  const positionDispatch = useContext(DispatchPositionContext);
  const positionState = useContext(StatePositionContext);
  const isAnonymous = positionState.single.anon;
  const { isSelected, selectedIds } = useKanbanState();
  const { toggleSelection } = useKanbanDispatch();
  const hasSelections = selectedIds.size > 0;

  const [isActive, setIsActive] = useState(application.id === activeApplicationId);

  useEffect(() => {
    setIsActive(application.id === positionState.appId);
  }, [application.id, activeApplicationId, positionState.appId]);

  return (
    <>
      <KanbanCardContainer
        {...(isActive ? { active: true } : {})}
        initial={initial || !positionState.candidateView}
        isSelected={isSelected(application.id)}
        onClick={() => {
          if (manageShareholder) {
            return;
          }
          if (!manageShareholder) {
            if (positionState.selectedApplication?.id !== application.id || !positionState.candidateView) {
              positionDispatch({
                type: "fetch_selected_application",
                payload: {
                  id: application.id,
                  substatus: application.substatus,
                },
              });
              setActiveApplicationId(application?.id);
            }
            setInitial(false);
          }
        }}
      >
        <Row ml="0" mr="0">
          <Flex height="100%" position="relative">
            {application.status === "invited" && (
              <IsInvited>
                <Typography tag="span">{t("component.kanbanCard.invited", "Invited").toUpperCase()}</Typography>
              </IsInvited>
            )}
            {!manageShareholder && application.status !== "invited" && application.status !== "rejected" && application.substatus !== "to_be_rejected" && (
              <KanBanSelector
                type="checkbox"
                id={`application-selector-${application.id}`}
                name={`application-selector`}
                $visible={hasSelections}
                checked={isSelected(application.id)}
                onClick={(event) => event.stopPropagation()} // Prevent click from bubbling up to the card's onClick
                onChange={() => toggleSelection(application.id)}
                value={application.id}
              />
            )}
            <KanbanCardAvatar avatar={avatar} isAnonymous={isAnonymous}>
              {!isAnonymous && (
                <Typography tag="p" mb="0" bold light>
                  {candidateInitials}
                </Typography>
              )}
            </KanbanCardAvatar>
            <KanbanContent isAnonymous={isAnonymous}>
              <Typography tag="h3" nomargin bold title={hasLongName ? candidateFullName : undefined}>
                {candidateDisplayName}
              </Typography>

              <Typography tag="p" mb="0" lowOpacity>
                {createdAtLabel}
              </Typography>
            </KanbanContent>
          </Flex>
        </Row>
        <Row ml="0" mr="0">
          <KanbanCardStars application={application} disabled={manageShareholder} />
        </Row>
      </KanbanCardContainer>
    </>
  );
};

export default KanbanCard;
